<template>
	<div class="ak3 ak">
		<div class="banner" id="banner3"><div class="banner-pro"></div></div>
		<div class="page-main-content">
			<div class="section2">
				<p class="text">{{text.second.text}}</p>
				<i class="airicon"></i>
			</div>
			<div class="section3">
				<img
					class="s3mobile-bg hidden"
					src="../assets/image/ak/easyset-mobile.jpg"
					alt=""
				/>
				<div class="desc-text easyplan">
					<h3 class="title">{{text.third[0].title}}</h3>
					<p class="text">{{text.third[0].text}}</p>
				</div>
				<div class="desc-text autonomous">
					<h3 class="title">{{text.third[1].title}}</h3>
					<p class="text">{{text.third[1].text}}</p>
				</div>
				<div class="redline rline">
					<div class="whiteline wline">
						<div class="dattedline dline"></div>
					</div>
				</div>
				<img
					class="redline-mobile rline hidden"
					src="../assets/image/ak/redline-mobile.png"
					alt=""
				/><i class="whiteline-mobile wline hidden"></i
				><img
					v-if="$route.params.lang === 'EN'"
					class="dline dattedline-mobile hidden"
					src="../assets/image/ak/airline-mobile-en.png"
					alt=""
				/>
				<img
					v-else
					class="dline dattedline-mobile hidden"
					src="../assets/image/ak/airline-mobile.png"
					alt=""
				/><img class="airplane" src="../assets/image/ak/airplane.png" alt="" />
			</div>
			<div class="section section4 section4-ak2">
				<img
					class="section4bg-mobile hidden"
					src="../assets/image/ak/ak2yth-designbg.jpg"
					alt=""
				/>
				<div class="section-text">
					<h3 class="title">{{text.forth.title}}</h3>
					<p class="text">{{text.forth.text}}</p>
				</div>
			</div>
			<div class="section section5">
				<img
					v-if="$route.params.lang === 'EN'"
					class="section5bg-mobile hidden"
					src="../assets/image/ak/security-stability-mobile-en.png"
					alt=""
				/>
				<img
					v-else
					class="section5bg-mobile hidden"
					src="../assets/image/ak/security-stability-mobile.jpg"
					alt=""
				/>
				<div class="section-text">
					<h3 class="title">{{text.fifth.title}}</h3>
					<p class="text">{{text.fifth.text}}</p>
				</div>
			</div>
			<div class="section section6">
				<div class="section-text">
					<h3 class="title">{{text.sixth.title}}</h3>
					<p class="text">{{text.sixth.text}}</p>
				</div>
				<div class="interface">
					<i class="arrow1"></i>
					<p class="arrow1-text">{{text.sixth.tips[0]}}</p>
					<i class="arrow2"> </i
					><img
						v-if="$route.params.lang==='EN'"
						class="interface-mobile hidden"
						src="../assets/image/ak/interface-mobile-en.png"
						alt=""
					/><img
						v-else
						class="interface-mobile hidden"
						src="../assets/image/ak/interface-mobile.png"
						alt=""
					/>
					<p class="arrow2-text">{{text.sixth.tips[1]}}</p>
				</div>
			</div>
			<div class="section7">
				<h3 class="title">{{text.paramsTitle}}</h3>
				<div class="detaild-table ak-table ak3-table">
					<div v-for="(item, index) in text.params" :key="index">
						<p class="its-title">{{item.title}}</p>
						<ul class="its-table">
							<li v-for="(v,k) in item.children" :key="k">
								<dl class="its-dl">
									<dt class="its-dt">{{v.title}}</dt>
									<dd class="its-dd">
										<ul>
											<li v-for="(t, i) in v.children" :key="i">
												<p>{{t}}</p>
											</li>
										</ul>
									</dd>
								</dl>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>
<script>
import { init } from "@/js/ak.js";
import { AK3 } from '@/js/text.js';
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'ak3',
	metaInfo: {
		meta: [{
			name: 'keywords', 
			content: '军工级,飞控,GNSS,飞控,固定翼,PowerPC,传感器,电力,测绘,农林,侦察,巡检,自主飞行,自动降落,航线飞行,GPS,气压传感器'
		},{
			name: 'description', 
			content: 'AK3是一款针对军工级大型、长航时固定翼无人机打造的高可靠性、高性能、高安全性飞控。AK3内置高精度姿态传感器、磁航向、静压、空速传感器、数传电台以及双备份GNSS接收机，具有高集成度和出色的系统可靠性。AK3外部具有丰富的接口资源，可扩展各种设备，采用PowerPC 处理器，运行实时操作系统，确保了软件安全、可靠的运行，并具有较高的抗干扰能力。该飞控以高性价比进入工业领域，受到众多用户的肯定，现已广泛用于海事、军事、侦查、电力、气象等领域。'
		}]
	},
	data() {
		return{}
	},
	components: {
		Foot: () => import("@/components/footer.vue"),
	},
	computed: {
		...mapState(['headerStyle']),
		text() {
			return this.$route.params.lang === 'CN' ? AK3.CN : AK3.EN
		}
	},
	methods: {
		...mapMutations(['setHeaderStyle'])
	},
	mounted() {
		init(this)
		this.setHeaderStyle({headerStyle: 'light'})
	},
	beforeDestroy() {
		window.onscroll = null
	}
}
</script>

<style lang="scss">
@import '@/assets/css/ak';
</style>
